module.exports = __webpack_public_path__ + "img/vallendeman_alleenman_600x600px.0eec9b8b.png";